import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const CollectionTrendChart = ({ data = [], color = "var(--dashboard-success)" }) => (
  <ResponsiveContainer width="100%" height={220}>
    <LineChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
      <CartesianGrid
        strokeDasharray="3 0"
        vertical={false}
        stroke="var(--dashboard-gray-200)"
      />
      <XAxis
        dataKey="name"
        tick={{ fontSize: 11, fill: "var(--dashboard-gray-500)" }}
        axisLine={false}
        tickLine={false}
      />
      <YAxis
        tick={{ fontSize: 11, fill: "var(--dashboard-gray-500)" }}
        axisLine={false}
        tickLine={false}
      />
      <Tooltip formatter={(value) => [`₹${Number(value).toLocaleString()}`, "Amount"]} />
      <Line
        type="monotone"
        dataKey="value"
        stroke={color}
        strokeWidth={2.5}
        dot={false}
        activeDot={{ r: 5 }}
      />
    </LineChart>
  </ResponsiveContainer>
);

export default CollectionTrendChart;
